import { ReferralModal } from '../../dashboard/financial-advisor/components/ReferralModal';
import { SPReferralModal } from '../../sp-client-management/components/SPReferralModal';
import { ShareContactCardModal } from '@/features/contact-card-share/components/ShareContactCardModal';
import { ShareConfirmationModal } from '../../../shared/components/ShareConfirmationModal';
import { RequestCallModal } from '../../consultations/components/RequestCallModal';
import { CalendlyBookingModal } from '../../consultations/components/CalendlyBookingModal';
import type { ShareContactCardProvider } from '@/features/contact-card-share/components/ShareContactCardModal';
import type { ProviderProfile } from '../types/provider-profile.types';
import { IntakeFormModal } from './IntakeFormModal';

type ProviderDetailsModalsProps = {
  provider: ProviderProfile;
  role: string | undefined;
  canReferProvider: boolean;
  canFavorite: boolean;
  providerDisplayName: string;
  profileViewEngagementId?: string;
  referralModalOpen: boolean;
  setReferralModalOpen: (open: boolean) => void;
  callRequestModalOpen: boolean;
  referralMarker?: string | null;
  setCallRequestModalOpen: (open: boolean) => void;
  calendlyModalOpen: boolean;
  setCalendlyModalOpen: (open: boolean) => void;
  intakeFormModalOpen: boolean;
  setIntakeFormModalOpen: (open: boolean) => void;
  showSharePrompt: boolean;
  setShowSharePrompt: (open: boolean) => void;
  onConfirmShare: () => void;
  onCancelShare: () => void;
  contactCard: {
    canShare: boolean;
    card: ShareContactCardProvider | null;
    open: boolean;
    setOpen: (open: boolean) => void;
    openShare: () => void;
  };
};

export function ProviderDetailsModals({
  provider,
  role,
  canReferProvider,
  canFavorite,
  providerDisplayName,
  profileViewEngagementId,
  referralModalOpen,
  setReferralModalOpen,
  callRequestModalOpen,
  referralMarker,
  setCallRequestModalOpen,
  calendlyModalOpen,
  setCalendlyModalOpen,
  intakeFormModalOpen,
  setIntakeFormModalOpen,
  showSharePrompt,
  setShowSharePrompt,
  onConfirmShare,
  onCancelShare,
  contactCard,
}: ProviderDetailsModalsProps) {
  return (
    <>
      {canReferProvider && role === 'FINANCIAL_ADVISOR' && (
        <ReferralModal
          open={referralModalOpen}
          onOpenChange={setReferralModalOpen}
          providerId={provider.id}
          providerName={providerDisplayName}
          profileViewEngagementId={profileViewEngagementId}
        />
      )}
      {canReferProvider && role === 'SERVICE_PROVIDER' && (
        <SPReferralModal
          open={referralModalOpen}
          onOpenChange={setReferralModalOpen}
          providerId={provider.id}
          providerName={providerDisplayName}
          profileViewEngagementId={profileViewEngagementId}
          onSendContactCard={
            contactCard.canShare
              ? () => {
                  setReferralModalOpen(false);
                  contactCard.openShare();
                }
              : undefined
          }
        />
      )}
      {contactCard.canShare && contactCard.card && (
        <ShareContactCardModal
          open={contactCard.open}
          onOpenChange={contactCard.setOpen}
          serviceProviderId={contactCard.card.id}
          provider={contactCard.card}
        />
      )}
      {/* Feature 102: primary care-seeker contact action */}
      {canFavorite && (
        <RequestCallModal
          open={callRequestModalOpen}
          onOpenChange={setCallRequestModalOpen}
          providerId={provider.id}
          providerName={providerDisplayName}
          profileViewEngagementId={profileViewEngagementId}
          referralMarker={referralMarker}
        />
      )}
      {canFavorite && provider.calendlyUrl && (
        <CalendlyBookingModal
          open={calendlyModalOpen}
          onOpenChange={setCalendlyModalOpen}
          providerId={provider.id}
          providerCompanyName={provider.companyName}
          calendlyUrl={provider.calendlyUrl}
          profileViewEngagementId={profileViewEngagementId}
        />
      )}
      {canFavorite && provider.intakeFormUrl && (
        <IntakeFormModal
          open={intakeFormModalOpen}
          onOpenChange={setIntakeFormModalOpen}
          providerId={provider.id}
          url={provider.intakeFormUrl}
        />
      )}
      <ShareConfirmationModal
        open={showSharePrompt}
        onOpenChange={setShowSharePrompt}
        itemType="provider"
        itemName={providerDisplayName}
        onConfirm={onConfirmShare}
        onCancel={onCancelShare}
      />
    </>
  );
}
